var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('send-email-modal'),_c('send-whatsapp-modal'),_c('confirmation-modal',{attrs:{"cancel":_vm.close,"confirm":_vm.deleteRow,"title":"Confirme exclusão de orçamento","message":"Tem certeza que deseja excluir esse orçamento?"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }